import React from 'react'
import { Card, CardContent } from 'components/Card'
import { observer } from 'mobx-react'
import cx from 'classnames'
import { ScopeChangeRequestStatusFilter } from 'admin/scope-change-requests/ScopeChangeRequestsSearchViewModel'
import { SingleSelectFilter } from 'infra/FilterControls/SingleSelect/SingleSelectFilter'
import styles from './ScopeChangeRequestStatusFilter.sass'

interface ScopeChangeRequestStatusFilterProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, ScopeChangeRequestStatusFilter>
}

export default observer(function ScopeChangeRequestStatusFilter<
  TFilters extends Record<string, unknown>,
>({ filter }: ScopeChangeRequestStatusFilterProps<TFilters>) {
  return (
    <div className={styles.root}>
      <h1>{filter.title}</h1>
      <div className={styles.cardsContainer}>
        {filter.options.map((opt) => (
          <ScopeChangeRequestFilterCard
            key={opt.value.type}
            title={opt.title}
            option={opt.value}
            filter={filter}
          />
        ))}
      </div>
    </div>
  )
})

interface ScopeChangeRequestFilterCardProps<
  TFilters extends Record<string, unknown>,
> {
  title: string
  option: ScopeChangeRequestStatusFilter
  filter: SingleSelectFilter<keyof TFilters, ScopeChangeRequestStatusFilter>
}

const ScopeChangeRequestFilterCard = observer(
  function ScopeChangeRequestFilterCard<
    TFilters extends Record<string, unknown>,
  >({ title, option, filter }: ScopeChangeRequestFilterCardProps<TFilters>) {
    return (
      <button
        className={cx(
          styles.filterCardContainer,
          filter.value.type === option.type && styles.active,
        )}
        onClick={() => filter.change(option)}
      >
        <Card borderless>
          <CardContent compact>
            <div
              className={cx(
                styles.filterCardContent,
                styles[`requestVariant-${option.type}`],
              )}
            >
              <h2>{title}</h2>
              <h1>{option.count}</h1>
            </div>
          </CardContent>
        </Card>
      </button>
    )
  },
)
